// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__25r2f","name":"ConsentHeader_name__2Z87t","birthday":"ConsentHeader_birthday__3V6NK","skeleton":"ConsentHeader_skeleton__1ynmS"};